class PlusModel {
  constructor(obj) {
    this.sourceString = '';
    this.items = [];

    if (obj) {
      Object.assign(this, obj);
    }
  }

  get dto() {
    return {
      sourceString: this.sourceString,
    };
  }
}

export default PlusModel;
